import { useMemo } from 'react';
import { Button, useDisclosure, useQueryState } from '@ywwwtseng/react-kit';
import { Wallet } from 'lucide-react';
import { useWalletKitConnect } from '@ywwwtseng/wallet-kit';
import { useTonWalletKit } from '@ywwwtseng/ton-wallet-kit';
import { Spinner } from '@/components/icons';
import { type SelectUser } from '@/types';
import { WalletConnectModal } from './WalletConnectModal';

export function ConnectWalletButton() {
  const walletKitConnect = useWalletKitConnect();
  const tonWalletKit = useTonWalletKit();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const me = useQueryState<SelectUser>('me');
  const isPending = walletKitConnect.isConnectPending || walletKitConnect.isSendTxPending;


  const icon = useMemo(() => {
    if (isPending) {
      return <Spinner width={24} height={24} />;
    }

    return <Wallet width={24} height={24} strokeWidth={2} />;
  }, [isPending]);

  return (
    <>
      <Button
        variant="icon"
        color={
          walletKitConnect.accounts.solana || tonWalletKit.connected
            ? 'secondary'
            : 'primary'
        }
        size="sm"
        disabled={isPending}
        onClick={() => {
          if (!me) {
            throw new Error('Me is not found');
          }

          onOpen();
        }}
      >
        {icon}
      </Button>
      <WalletConnectModal open={isOpen} onCloseAction={onClose} />
    </>
  );
}
